import Head from "next/head";
import React from "react";

import Container from "@components/Container";
import Hero from "@components/Hero";
import MainLayout from "@components/MainLayout";
import RefundPolicyContainer from "@components/RefundPolicyContainer";
import Spacer from "@components/Spacer";

const TermsPage = () => (
  <>
    <Head>
      <title>Refund Policy | genie</title>
    </Head>
    <Hero />
    <Spacer size="md" />
    <Container>
      <RefundPolicyContainer />
    </Container>
  </>
);

TermsPage.Layout = MainLayout;

export default TermsPage;
